<template>
    <v-footer color="dark" tile class="pt-6 mt-10">
        <v-container class="py-0">
            <v-row>
                <v-col md="6" cols="12">
                    <h3>{{ $store.state.client_vars.footer.footerHeader }}</h3>
                </v-col>
                <v-col md="6" cols="12">
                    <a class="float-right" :href="$store.state.client_vars.footer.footerLogoLink"><img class="footer-logo" :src="$store.state.client_vars.footer.footerLogo" /></a>
                </v-col>
            </v-row>
            <!-- <v-row>
                <v-col sm="auto" cols="12" class="py-sm-0" :class="item.alignment" v-for="item in footerArr" :key="item.id">
                    <h4 class="mb-0">
                        {{ item.title }}
                    </h4>
                    <div v-html="item.content">
                    </div>
                </v-col>
            </v-row> -->
            <v-row>
                <v-col cols="12" class="py-4">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="pb-4 pt-0 mr-auto">
                    <p class="copyright">
                        ©{{ $store.state.client_vars.footer.footerCopyright }}
                    </p>
                </v-col>
            </v-row>
            <div class="footer__support-your-local">
                <img src="@/assets/support-your-local.svg">
            </div>
            <div class="footer__row-of-houses">
                <img src="@/assets/houses.svg">
            </div>
        </v-container>
    </v-footer>
</template>

<script>
    export default {
        footerLogo() {
            return this.$store.getters.getFooterLogo
        },
        footerLogoLink() {
            return this.$store.getters.getFooterLogoLink
        },
        data() {
            return {
                footerArr: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.FOOTER)
                .then(response => {
                    this.footerArr = response.data
                })
                .catch(error => {
                    console.log('Failed to update footer links')
                })
        }
    }
</script>

<style lang="scss">

.v-footer {

    hr {
        background-color: #979797;
        opacity: 0.2;
    }

    p, a {
        font-size: 16px;
        color: white;
        font-weight: 500;
        text-decoration: none;;
        margin-bottom: 0;

        &.copyright {
            font-size: 12px;
            font-weight: 500;
            margin-bottom: 0;
            color: #fff;
            opacity: 0.65;
            text-align: center;
        }
    }

    a {
        color: white!important;
    }

    h3 {
        color: white;
        font-size: 18px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 2px;
        line-height: 3;
    }

    h4 {
        color: var(--v-secondary-base);
        font-size: 18px;
        line-height: 24px;
    }

    p {
        font-size: 16px;
        line-height: 24px;
    }

    .container {
        position: relative;

        @media (min-width: 992px) and (max-width:1903px) {
            max-width: 1250px;
        }
    }

    .footer__support-your-local {
        position: absolute;
        top: -110px;
        left: 0;
    }

    .footer__row-of-houses {
        position: absolute;
        top: -70px;
        right: 0;

        @media all and (max-width: 680px) {
            display: none;
        }
    }

    .footer-logo {
        max-width: 298px;
    }
}
</style>